module.exports = __webpack_public_path__ + "img/page4.71aca4d3.jpeg";